import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="filter"
export default class extends Controller {
  static targets = ['template', 'destination']

  rules = []

  unique_id = undefined

  connect() {
    this.unique_id = crypto.randomUUID()
  }

  handle({ params, target }) {
    if (target.checked) {
    }
  }

  apply({ detail }) {
    let rule = this.rules.find(r => r.args[0] == detail.args[0] && r.operator == detail.operator)
    if (rule) {
      rule.args = detail.args
    } else {
      this.rules.push({ operator: detail.operator, args: detail.args })
    }

    this.dispatch("change", {
      detail: { rules: this.rules, unique_id: this.unique_id }
    })
  }

  remove({ detail }) {
    console.log("remove", detail, this.unique_id)
    this.rules = this.rules.filter((r) => {
      return !(r.operator == detail.operator && r.args[0] == detail.args[0] && r.args[1] == detail.args[1])
    })

    this.dispatch("change", {
      detail: { rules: this.rules, unique_id: this.unique_id }
    })

    if (this.rules.length == 0) {

      //this.element.remove()
    }
  }


  duplicate({ target }) {
    this.destinationTarget.insertAdjacentHTML("beforeend", this.templateTarget.innerHTML)
    target?.remove()
  }

}
